import { getDefaultState } from "./state";
import { Payment } from "./interfaces";

export const setPaymentSessionToken = (state: Payment, token: string) => {
  state.paymentSessionToken = token;
};

export const setPaymentSessionKey = (state: Payment, key: string) => {
  state.paymentSessionKey = key;
};

export const setFPPaymentKey = (state, paymentKey) => {
  state.FPPaymentKey = paymentKey;
};

export const resetState = (state: Payment): void => {
  Object.assign(state, getDefaultState());
};
